import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import Box from '../../uikit/Box';
import Frame from '../../uikit/Frame';
import { useMobxInstance } from '../../clientUtils/mobxUtil';
import NewsList from './NewsList';
import MetaHeader from '../MetaHeader';
import Jsonld from '../Jsonld';
import FeaturedStockCard from '../featured/FeaturedStockCard';

class ViewStore {
    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {}
}

const NewsListPage = observer(() => {
    const viewStore = useMobxInstance(ViewStore);

    useEffect(() => {
        viewStore.fetch();
    }, [viewStore]);

    const title = '주요 해외뉴스';
    const description =
        '투자에 꼭 필요한 해외 경제뉴스를 사건, 시장 반응, 해석, 결론 등으로 간결하게 정리했습니다. 복잡한 경제 이슈도 한 번에 파악할 수 있어요.';

    return (
        <Frame>
            <MetaHeader title={title} description={description} />
            <Jsonld type="Blog" title={title} description={description} />
            <Frame.Title title={title} />
            <Box>
                <NewsList />
            </Box>
            <Frame.BottomSpacer />
        </Frame>
    );
});

export default NewsListPage;
